export enum RecentEventSourceType {
    OE417 = 2,
    NATURALGAS = 3,
    ISO = 4,
}
